import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TimeAgoComponent } from './time-ago.component';

@NgModule({
  imports: [CommonModule, MatTooltipModule],
  declarations: [TimeAgoComponent],
  exports: [TimeAgoComponent],
})
export class TimeAgoModule {}
